import React from "react"
import MerchantItem from "../../merchant-item/merchant-item"

export default function MerchantPageOtherStores({ headline, merchants, bottomPadding, topPadding, topDeck, cssClass }) {
  let lessThanFour = merchants?.length < 4

  if (merchants?.length > 0)
    return (
      <div className={`shoppage__other-stores ${cssClass ? cssClass : "same-stores"}`}>
        <div
          className={`shoppage__other-stores__content w--wider ${bottomPadding ? bottomPadding : ""} ${topPadding ? topPadding : ""} ${topDeck ? topDeck : ""}`}
        >
          <h3 className="rich-text" dangerouslySetInnerHTML={{ __html: headline }}></h3>
          <div className={`store-items${lessThanFour ? " short-list" : " long-list"}`}>
            {merchants && merchants.length > 0
              ? merchants.map((merchant, index) => {
                  const dayOfWeek = new Date().getDay()
                  const openingHoursForTheDay =
                    merchant.openingHours &&
                    [
                      merchant.openingHours.sundayOpening,
                      merchant.openingHours.mondayOpening,
                      merchant.openingHours.tuesdayOpening,
                      merchant.openingHours.wednesdayOpening,
                      merchant.openingHours.thursdayOpening,
                      merchant.openingHours.fridayOpening,
                      merchant.openingHours.saturdayOpening,
                    ][dayOfWeek]
                  const closingHoursForTheDay =
                    merchant.openingHours &&
                    [
                      merchant.openingHours.sundayClosing,
                      merchant.openingHours.mondayClosing,
                      merchant.openingHours.tuesdayClosing,
                      merchant.openingHours.wednesdayClosing,
                      merchant.openingHours.thursdayClosing,
                      merchant.openingHours.fridayClosing,
                      merchant.openingHours.saturdayClosing,
                    ][dayOfWeek]
                  return (
                    <MerchantItem
                      key={index}
                      {...merchant}
                      cssClass={"store-item"}
                      link={merchant.merchantLink}
                      splashLabel={merchant.ribbonText}
                      isRibbonValid={merchant.isRibbonValid}
                      openingHoursForTheDay={openingHoursForTheDay}
                      closingHoursForTheDay={closingHoursForTheDay}
                    />
                  )
                })
              : ""}
          </div>
        </div>
      </div>
    )
  return null
}
